import * as Yup from 'yup';

export const passwordResetSchema = Yup.object().shape({
    email: Yup.string().email().required(),
});
